import forOwn from 'lodash/forOwn';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';

export { default as VatReturnModal } from './vat-return-modal';
export function getAllCtFields(obj) {
  let result = {};
  forOwn(obj, (value, key) => {
    if (/^ct\d+$/.test(key)) {
      result[key] = value;
    }
    if (isObject(value) && !isArray(value)) {
      result = { ...result, ...getAllCtFields(value) };
    }
  });
  return result;
}



// WEBPACK FOOTER //
// ./src/portal-components/value-added-tax/vat-return/vat-return-modal/index.js